import { createFileRoute } from "@tanstack/react-router";
import { MeowBanking } from "@/components/MeowBanking";

function RouteComponent() {
  return <MeowBanking />;
}

export const Route = createFileRoute("/_authenticated/meow-banking/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
